export class DispatchStatus {
  public static ALL_DISPATCH_STATUS: Map<string, DispatchStatus> = new Map();

  public static DRAFT = new DispatchStatus("DRAFT");
  public static SCHEDULED = new DispatchStatus("SCHEDULED");
  public static RUNNING = new DispatchStatus("RUNNING");
  public static COMPLETED = new DispatchStatus("COMPLETED");
  public static PAUSED = new DispatchStatus("PAUSED");
  public static PARTIALLY_CANCELLED = new DispatchStatus("PARTIALLY_CANCELLED");
  public static CANCELLED = new DispatchStatus("CANCELLED");
  public static PENDING_APPROVAL = new DispatchStatus("PENDING_APPROVAL");

  public static from(value: string) {
    return DispatchStatus.ALL_DISPATCH_STATUS.get(value) || null;
  }

  public value: string;

  constructor(value: string) {
    this.value = value;

    DispatchStatus.ALL_DISPATCH_STATUS.set(value, this);
  }

  public toJSON(): any {
    return this.value;
  }
}
